import { useEffect, useState } from "react"
import { useWorkflowSession } from "./workflowSession"
export function useWorkflowResource<T>(key: string, load: (signal: AbortSignal) => Promise<T>) {
  const { sessionKey } = useWorkflowSession()
  const [revision, setRevision] = useState(0)
  const full = `${sessionKey}/${key}/${revision}`
  const [state, setState] = useState<{ key: string; data?: T; error?: unknown }>({ key: "" })
  useEffect(() => {
    const controller = new AbortController()
    if (key)
      load(controller.signal)
        .then((data) => {
          if (!controller.signal.aborted) setState({ key: full, data })
        })
        .catch((error) => {
          if (!controller.signal.aborted && error?.name !== "AbortError")
            setState({ key: full, error })
        })
    return () => controller.abort()
    // The request key includes every input. Abort prevents late results replacing a newer request.
  }, [full])
  return {
    data: state.key === full ? state.data : undefined,
    error: state.key === full ? state.error : undefined,
    loading: !!key && state.key !== full,
    reload: () => setRevision((n) => n + 1),
  }
}
